// Enums.
import { IRecurrentFrequencyOptions } from 'modules/appointments/components/frequency-select/frequency-select.component';

import { ESidebarMode } from '../enums/sidebarmode.enum';
import { IBusySlot } from './availability.interface';

// Interface for sidebar content.
export interface ISidebar {
	mode: ESidebarMode;
	date?: Date;
	hour?: string;
	time?: Date;
	id?: string;
	type?: string;
	contactId?: number;
	scrollTo?: boolean;
	address?: string;
	price?: number;
	isBusySlot?: boolean;
	description?: string;
	recurrencyType?: IRecurrentFrequencyOptions;
	recurrencyId?: string;
	startDate?: Date;
	endDate?: Date;
	isReposition?: boolean;
	from?: AppointmentSidebarFrom;
}

export interface ISidebarBusySlot extends IBusySlot {
	mode: ESidebarMode;
}

export enum AppointmentSidebarFrom {
	SCHEDULE_MODAL = 'schedule_modal',
	HOME_SIDEBAR = 'home_sidebar',
	HOME = 'home',
	CALENDAR = 'calendar',
	CLIENTS = 'clients',
	OLD_USER_PROFILE = 'old_user_profile',
}
